import React from "react";
import PlanillaPageLayout from "./PlanillaPageLayout";

const RRHHMarcaciones = () => (
  <PlanillaPageLayout
    title="Marcaciones"
    description="Consulta y control de marcaciones de asistencia del personal."
  >
    <p className="text-muted mb-0">Panel de marcaciones próximamente.</p>
  </PlanillaPageLayout>
);

export default RRHHMarcaciones;
